export const validateRowsDataType = ({ rows, columns }) => {
  return rows.map((row) => {
    const newRow = { ...row };

    columns.forEach((column) => {
      const field = column.Field;
      const type = String(
        column.dataType || column.DataType || column.Type || "",
      ).toLowerCase();

      const value = row[field];

      // Numeric fields
      if (
        type.includes("int") ||
        type.includes("decimal") ||
        type.includes("numeric") ||
        type.includes("float") ||
        type.includes("double")
      ) {
        // Empty value should become null
        if (value === "" || value === undefined) {
          newRow[field] = null;
        }
        // Convert numeric string to number
        else if (typeof value === "string" && value.trim() !== "") {
          const numberValue = Number(value);

          newRow[field] = Number.isNaN(numberValue) ? null : numberValue;
        }
      }
    });

    return newRow;
  });
};
